import React from "react";

export const TermsForAccpet = () => {
    return (
        <div className="w-full flex justify-center">
            <div className="w-7/12 p-4 text-center">
                <strong>
                    Termos de uso, condições do Programa Impulso e política de
                    privacidade{" "}
                </strong>
                <p className="text-left mt-3">
                    É obrigatória a leitura das informações abaixo, onde constam
                    os critérios de participação, uso de dados e nossa Política
                    de Privacidade, seus direitos e como seus dados pessoais são
                    coletados, compartilhados e armazenados. Lei Geral de
                    Proteção de Dados Pessoais – LEI No. 13.709/2018.
                </p>
                ***
                <p className="text-left mt-3">
                    {" "}
                    Este documento descreve as práticas gerais de uso do
                    PROGRAMA IMPULSO, do Instituto GRPCOM. Descreve as condições
                    para o cadastro e diagnóstico (por parte das Organizações da
                    Sociedade Civil – OSC). Dedique alguns minutos para ler e
                    usufruir de forma consciente e segura do que o Programa
                    Impulso tem a oferecer.
                </p>
                ***
                <p className="text-left mt-3">
                    {" "}
                    Está habilitada a se cadastrar no PROGRAMA IMPULSO a
                    ORGANIZAÇÃO DA SOCIEDADE CIVIL (OSC) – entidade privada sem
                    fins lucrativos que não distribua entre os seus sócios ou
                    associados, conselheiros, diretores, empregados, doadores ou
                    terceiros, eventuais resultados, sobras, excedentes
                    operacionais, brutos ou líquidos, dividendos, isenções de
                    qualquer natureza, participações ou parcelas do seu
                    patrimônio, auferidos mediante o exercício de suas
                    atividades, e que os aplique integralmente na consecução do
                    respectivo objeto social de interesse público.
                </p>
                <p className="text-left mt-3">
                    {" "}
                    A ORGANIZAÇÃO DA SOCIEDADE CIVIL (OSC) que quiser se
                    cadastrar no PROGRAMA IMPULSO deve obedecer ao princípio da
                    universalidade do atendimento, sendo vedada a participação
                    da OSC que:
                </p>
                <p className="text-left pl-7 mt-1">
                    I. Dirijam suas atividades exclusiva ou preferencialmente a
                    seus associados ou a determinada categoria profissional.
                </p>
                <p className="text-left pl-7 mt-1">
                    II. Promovam atividades político-partidárias.
                </p>
                <p className="text-left pl-7 mt-1">
                    III. Descumpram os seus objetivos estatutários.
                </p>
                <p className="text-left pl-7 mt-1">
                    IV. Sejam criadas por iniciativa dos Poderes Executivo e
                    Legislativo municipal, estadual ou federal.
                </p>
                <p className="text-left pl-7 mt-1">
                    V. Tenham sido condenadas judicialmente por irregularidades
                    ou malversação de recursos públicos; (caso a entidade tenha
                    sido denunciada ou esteja sendo processada, deverá aguardar
                    o trânsito em julgado de sentença absolutória que reconheça
                    a inexistência de crime ou que ela não participou de
                    atividade ilícita para ingressar no Programa Impulso).
                </p>
                <p className="text-left pl-7 mt-1">
                    VI. Descumpram as condições que serão elencadas neste
                    documento.
                </p>
                <p className="text-left mt-3">
                    {" "}
                    Para fins de atendimento no PROGRAMA IMPULSO, considera-se
                    objeto social de interesse público:
                </p>
                <p className="text-left pl-7 mt-1">
                    {"a) "} A promoção da assistência social.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"b) "} A promoção da educação.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"c) "} A promoção da saúde.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"d) "} A promoção da segurança alimentar e nutricional.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"e) "} A defesa, preservação e conservação do meio ambiente
                    e promoção do desenvolvimento sustentável.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"f) "} A promoção do voluntariado.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"g) "} A promoção do desenvolvimento econômico e social e
                    combate à pobreza.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"h) "} A promoção de direitos estabelecidos e construção de
                    novos direitos.
                </p>
                <p className="text-left pl-7 mt-1">
                    {"i) "} A promoção da ética, da paz, da cidadania, dos
                    direitos humanos, da democracia e de outros valores
                    universais.
                </p>
                <p className="text-left mt-3">
                    {" "}
                    Todas as explicações a respeito do funcionamento do
                    Diagnóstico estão apresentadas nesta página:
                    <a
                        className="text-primary-dark"
                        target={"_blank"}
                        rel="noreferrer noopener"
                        href="http://programaimpulso.org.br/diagnostico."
                    >
                        {" "}
                        http://programaimpulso.org.br/diagnostico{" "}
                    </a>
                    . As informações relativas ao cadastro e/ou diagnóstico não
                    serão comercializadas ou fornecidas a terceiros, salvo em
                    estrito cumprimento de ordens judiciais, mas poderão ser
                    utilizadas para gerar dados estatísticos gerais com
                    finalidade informativa.
                </p>
                <p className="text-left mt-3">
                    {" "}
                    Informações geográficas, demográficas, e de perfil de uso
                    dos usuários do PROGRAMA IMPULSO poderão ser fornecidas a
                    parceiros, patrocinadores ou outras empresas externas sem
                    que sejam revelados nomes ou outros dados de navegação.
                </p>
                <p className="text-left mt-3">
                    {" "}
                    Ao realizar seu cadastro a OSC autoriza e aceita receber
                    informações sobre o Programa Impulso ou outras ações
                    promovidas e apoiadas pelo Instituto GRPCOM relacionadas ao
                    terceiro setor a partir da presente data em seu e-mail e
                    telefone.
                </p>
                <p className="text-left mt-3">
                    {" "}
                    Para ler a a Política de privacidade do Instituto GRPCOM,
                    clique aqui{" "}
                    <a
                        className="text-primary-dark"
                        target={"_blank"}
                        rel="noreferrer noopener"
                        href="http://programaimpulso.org.br/politica-de-privacidade/"
                    >
                        {"("}
                        http://programaimpulso.org.br/politica-de-privacidade/
                        {")"}
                    </a>
                    .
                </p>
                <p className="text-left mt-3">
                    {" "}
                    Ao clicar no aceite na página anterior, estou ciente e
                    concorde dos termos acima.
                </p>
            </div>
        </div>
    );
};
